/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateDashboardRequest } from '../model';
// @ts-ignore
import { DashboardDetailResponse } from '../model';
// @ts-ignore
import { DashboardListItemResponse } from '../model';
// @ts-ignore
import { DashboardType } from '../model';
// @ts-ignore
import { UpdateDashboardRequest } from '../model';
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
export const DashboardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validation is type-aware: INSIGHTS requires subType, PAGINATED insights require datasetId, SUMMARY requires entityType, and fields that do not apply to the requested type are rejected.
         * @summary Create a dashboard.
         * @param {CreateDashboardRequest} createDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard: async (createDashboardRequest: CreateDashboardRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDashboardRequest' is not null or undefined
            assertParamExists('createDashboard', 'createDashboardRequest', createDashboardRequest)
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Also removes its role assignments and, for a SUMMARY dashboard, its filter and filter restrictions.
         * @summary Delete a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard: async (dashboardId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('deleteDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboardId}`
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get full dashboard detail by ID.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (dashboardId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboardId}`
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Slim rows for the admin grid, ordered by last-written date descending. Full detail comes from GET /dashboards/{dashboardId}.
         * @summary List dashboards for the authenticated user\'s organization.
         * @param {DashboardType} [type] Restricts the result to one dashboard type. Omit for all types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards: async (type?: DashboardType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A full replacement: an omitted roleIds or filterRestrictions clears rather than preserves. The dashboard type cannot be changed. For a SUMMARY dashboard, a new filterRestrictions expression replaces the stored one and an empty list clears it.
         * @summary Update a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {UpdateDashboardRequest} updateDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard: async (dashboardId: number, updateDashboardRequest: UpdateDashboardRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'updateDashboardRequest' is not null or undefined
            assertParamExists('updateDashboard', 'updateDashboardRequest', updateDashboardRequest)
            const localVarPath = `/dashboards/{dashboardId}`
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardsApi - functional programming interface
 * @export
 */
export const DashboardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Validation is type-aware: INSIGHTS requires subType, PAGINATED insights require datasetId, SUMMARY requires entityType, and fields that do not apply to the requested type are rejected.
         * @summary Create a dashboard.
         * @param {CreateDashboardRequest} createDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDashboard(createDashboardRequest: CreateDashboardRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDashboard(createDashboardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Also removes its role assignments and, for a SUMMARY dashboard, its filter and filter restrictions.
         * @summary Delete a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboard(dashboardId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboard(dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get full dashboard detail by ID.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(dashboardId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Slim rows for the admin grid, ordered by last-written date descending. Full detail comes from GET /dashboards/{dashboardId}.
         * @summary List dashboards for the authenticated user\'s organization.
         * @param {DashboardType} [type] Restricts the result to one dashboard type. Omit for all types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDashboards(type?: DashboardType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDashboards(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A full replacement: an omitted roleIds or filterRestrictions clears rather than preserves. The dashboard type cannot be changed. For a SUMMARY dashboard, a new filterRestrictions expression replaces the stored one and an empty list clears it.
         * @summary Update a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {UpdateDashboardRequest} updateDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDashboard(dashboardId: number, updateDashboardRequest: UpdateDashboardRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDashboard(dashboardId, updateDashboardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardsApi - factory interface
 * @export
 */
export const DashboardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardsApiFp(configuration)
    return {
        /**
         * Validation is type-aware: INSIGHTS requires subType, PAGINATED insights require datasetId, SUMMARY requires entityType, and fields that do not apply to the requested type are rejected.
         * @summary Create a dashboard.
         * @param {CreateDashboardRequest} createDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard(createDashboardRequest: CreateDashboardRequest, options?: any): AxiosPromise<DashboardDetailResponse> {
            return localVarFp.createDashboard(createDashboardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Also removes its role assignments and, for a SUMMARY dashboard, its filter and filter restrictions.
         * @summary Delete a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard(dashboardId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get full dashboard detail by ID.
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(dashboardId: number, options?: any): AxiosPromise<DashboardDetailResponse> {
            return localVarFp.getDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Slim rows for the admin grid, ordered by last-written date descending. Full detail comes from GET /dashboards/{dashboardId}.
         * @summary List dashboards for the authenticated user\'s organization.
         * @param {DashboardType} [type] Restricts the result to one dashboard type. Omit for all types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards(type?: DashboardType, options?: any): AxiosPromise<Array<DashboardListItemResponse>> {
            return localVarFp.listDashboards(type, options).then((request) => request(axios, basePath));
        },
        /**
         * A full replacement: an omitted roleIds or filterRestrictions clears rather than preserves. The dashboard type cannot be changed. For a SUMMARY dashboard, a new filterRestrictions expression replaces the stored one and an empty list clears it.
         * @summary Update a dashboard.
         * @param {number} dashboardId Dashboard ID
         * @param {UpdateDashboardRequest} updateDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(dashboardId: number, updateDashboardRequest: UpdateDashboardRequest, options?: any): AxiosPromise<DashboardDetailResponse> {
            return localVarFp.updateDashboard(dashboardId, updateDashboardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
export class DashboardsApi extends BaseAPI {
    /**
     * Validation is type-aware: INSIGHTS requires subType, PAGINATED insights require datasetId, SUMMARY requires entityType, and fields that do not apply to the requested type are rejected.
     * @summary Create a dashboard.
     * @param {CreateDashboardRequest} createDashboardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public createDashboard(createDashboardRequest: CreateDashboardRequest, options?: any) {
        return DashboardsApiFp(this.configuration).createDashboard(createDashboardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Also removes its role assignments and, for a SUMMARY dashboard, its filter and filter restrictions.
     * @summary Delete a dashboard.
     * @param {number} dashboardId Dashboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public deleteDashboard(dashboardId: number, options?: any) {
        return DashboardsApiFp(this.configuration).deleteDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get full dashboard detail by ID.
     * @param {number} dashboardId Dashboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getDashboard(dashboardId: number, options?: any) {
        return DashboardsApiFp(this.configuration).getDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Slim rows for the admin grid, ordered by last-written date descending. Full detail comes from GET /dashboards/{dashboardId}.
     * @summary List dashboards for the authenticated user\'s organization.
     * @param {DashboardType} [type] Restricts the result to one dashboard type. Omit for all types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public listDashboards(type?: DashboardType, options?: any) {
        return DashboardsApiFp(this.configuration).listDashboards(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A full replacement: an omitted roleIds or filterRestrictions clears rather than preserves. The dashboard type cannot be changed. For a SUMMARY dashboard, a new filterRestrictions expression replaces the stored one and an empty list clears it.
     * @summary Update a dashboard.
     * @param {number} dashboardId Dashboard ID
     * @param {UpdateDashboardRequest} updateDashboardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public updateDashboard(dashboardId: number, updateDashboardRequest: UpdateDashboardRequest, options?: any) {
        return DashboardsApiFp(this.configuration).updateDashboard(dashboardId, updateDashboardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
